import { getSrcs } from '@helpers/image';
import { FakeButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import S from './CategoryCard.styles';
import { FocusRing } from 'react-aria';
const CategoryCard = ({ cta, image, mobileImage, summary, title, theme = 'light', }) => {
    const srcs = getSrcs(image, 1000, 750, 4);
    const mobileSrcs = getSrcs(mobileImage ?? image, 750, 375, 4);
    return (React.createElement(AnchorWrapper, { cta: cta, theme: theme },
        React.createElement(S.Inner, null,
            React.createElement(S.MediaHolder, null,
                React.createElement(S.ImageDesktop, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') }),
                React.createElement(S.ImageMobile, { alt: mobileImage?.altText ?? '', loading: "lazy", role: mobileImage?.altText ? undefined : 'presentation', src: mobileSrcs[0].split(' ')[0], srcSet: mobileSrcs.join(',') })),
            React.createElement(S.ContentArea, null,
                React.createElement(S.ContentInner, null,
                    React.createElement(S.Title, null, title),
                    summary && (React.createElement(S.Intro, { dangerouslySetInnerHTML: { __html: summary } })),
                    cta?.url && (React.createElement(S.FakeButton, null,
                        React.createElement(FakeButton, { styleType: "underline", backgroundPlacement: theme, branding: "blue", buttonSize: "large", title: cta.text || 'Read More' }))))))));
};
const AnchorWrapper = ({ cta, theme, children }) => {
    if (!cta?.url) {
        return React.createElement(S.ArticleContainer, { "data-theme": theme }, children);
    }
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { href: cta.url, "data-theme": theme, target: cta.target ?? '_self' }, children)));
};
export default CategoryCard;
